import { useEffect, useState } from "react";

import L from 'leaflet';

import { loadGEO } from "../../../helpers/helpers";
import { flip } from "turf";

const l = L.featureGroup();          

export const WaterLevel = ({mapRef}) => {

    const waterOptions = { color: 'blue', border: '0' };        

    useEffect(() => {
        loadGEO('wl')
        .then((data) => {
            onDraw(flip(data));
        });
        return () => {
            onClear();
        }
    }, []);

    const onDraw = ( polygons ) => {        

        if (polygons.features.length > 0) {
            polygons.features.forEach((feature, index) => {                
                const line = L.polyline([feature.geometry.coordinates], waterOptions)
                .bindPopup(feature?.properties?.name)
                .bindTooltip(feature?.properties?.name, {sticky: true});
                l.addLayer(line);
            })
        }
        l
            .bringToFront()
            .addTo(mapRef.current);

    }

    const onClear = () => {
        l.clearLayers();        
    }
    
    return;

}